




































































































































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Booking } from '@/api';
import { apiBase, apiNamespace } from '@/config';
import BookingExtras from '@/components/admin/BookingExtras.vue';

@Component({
  components: { BookingExtras },
})
export default class extends Vue {
  @Prop({ required: false }) readonly selectedBooking: Booking;

  get pdfUrl() {
    return (
      apiBase +
      apiNamespace +
      '/bookings/' +
      this.selectedBooking.id +
      '/invoice/'
    );
  }

  formatCurrency(amount: string) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(Number(amount));
  }

  close() {
    this.$emit('close-region');
  }
}
